import { Link } from 'react-router-dom';
import './Navbar.css';
import logoLong from '../assets/logo-long-black.png';

function Navbar() {
    return (
        <nav className="navbar">
            <div className="nav-container">
                <Link to="/">
                    <img src={logoLong} alt="Lemadoo" className="logo" />
                </Link>
                <div className="nav-links">
                    <Link to="/pricing" className="nav-link">
                        Pricing
                    </Link>
                    <a
                        href="https://app.lemadoo.com/sign-in"
                        className="nav-button-outline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Login
                    </a>
                    <a
                        href="https://app.lemadoo.com/sign-up"
                        className="cta-button"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span className="cta-label-full">Get Started - Free</span>
                        <span className="cta-label-short">Sign Up</span>
                    </a>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
